import { FunctionalComponent, h } from 'preact'
import '../../style/pages/home/reset.scss'
import '../../style/pages/home/index.scss'

const Home: FunctionalComponent = () => {
  return (
    <div class="service-ended">
      <div class="service-ended__card">
        <img src="/assets/images/home/logo.svg" alt="マンガトート" class="service-ended__logo" />
        <p class="service-ended__message">
          マンガトートは<span class="service-ended__date">2026年6月30日</span>にサービスを終了いたしました。
        </p>
        <a href="mailto:support@mangatote.jp" class="service-ended__button">
          お問い合わせ
        </a>
        <p class="service-ended__copyright">©2026 Amazia, Inc. All Rights Reserved.</p>
      </div>
    </div>
  )
}

export default Home
